export interface IconDefinition {
  name: string
  icon: any // This will be the actual icon component/value
  pack: string // The name of the icon pack this icon belongs to
  displayName?: string // Optional user-friendly name
}

export interface ExportArgs {
  icon: IconDefinition
  logo: any // logo object
}

export interface IconPack {
  name: string
  icons: IconDefinition[]
  getIconComponent: (
    icon: IconDefinition,
    size?: number,
    color?: string,
    rotate?: number
  ) => React.ReactNode
  exportSVG?: (args: ExportArgs) => string | undefined
  exportPNG?: (args: ExportArgs) => Promise<string | undefined>
}

export interface IconPackRegistry {
  [key: string]: IconPack
}

export async function svgStringToPng(
  svgString: string,
  size = 256
): Promise<string> {
  return new Promise((resolve) => {
    const img = new window.Image()
    const svg = new Blob([svgString], { type: 'image/svg+xml' })
    const url = URL.createObjectURL(svg)
    img.onload = function () {
      const canvas = document.createElement('canvas')
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, size, size)
      URL.revokeObjectURL(url)
      resolve(canvas.toDataURL('image/png'))
    }
    img.src = url
  })
}
